<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="aplicaciones" :search="search" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editAplicacion(item.id_aplicacion)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.nombre }}
                    ({{ itemToDelete.comentario }})
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar el Aplicacion?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteAplicacion(itemToDelete.id_aplicacion)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import AplicacionesDataService from "@/services/AplicacionesDataService";

export default {
    name: "AplicacionesList",
    data: () => ({
        aplicaciones: [],
        search: '',
        sortBy: 'nombre',
        sortDesc: false,
        headers: [
            { text: 'Nombre', value: 'nombre' },
            { text: 'Comentario', value: 'comentario' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        retrieveAplicaciones() {
            AplicacionesDataService.getAll()
                .then((response) => {
                    // console.log("APLICACIONES"); console.log(response.data);
                    this.aplicaciones = response.data.map(this.getDisplayAplicacion);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        editAplicacion(id) {
            this.$router.push({ name: "AplicacionId", params: { id: id } });
        },
        deleteAplicacion(id) {
            AplicacionesDataService.delete(id)
                .then(() => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.retrieveAplicaciones();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        getDisplayAplicacion(aplicacion) {
            return {
                id_aplicacion: aplicacion.id_aplicacion,
                comentario: aplicacion.comentario,
                nombre: aplicacion.nombre,
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveAplicaciones();
    }
};
</script>